import VwKimlikDTO from "src/models/Genel/VwKimlikDTO";
import { ApiService } from 'src/services/core';
import { helper } from "src/utils/helper";

class VwKimlikService {
    private service: ApiService<VwKimlikDTO>;
    constructor() {
        this.service = new ApiService<VwKimlikDTO>('VwKimlikDTO');
    }

    createUpdate = (data: VwKimlikDTO) => {
        data.adi = helper.upperCase(data.adi)
        data.soyadi = helper.upperCase(data.soyadi)
        data.aileAdi = helper.upperCase(data.aileAdi)
        data.kimlikNo = helper.upperCase(data.kimlikNo)
        data.pasaportNo = helper.upperCase(data.pasaportNo)
        data.seriNo = helper.upperCase(data.seriNo)
        if (data.id > 0)
            return this.service.update(data)
        else return this.service.create(data);
    }
    getByKimlikId = (id: number) => {
        return this.service.getOne(id);
    }

    getKimlikNoVarMi = (kimlikNo: string, kimlikId: number) => {
        return this.service.find({
            filters: {
                groupOperator: 'and',
                predicates: [
                    {
                        fieldName: 'kimlikNo',
                        operator: '=',
                        value1: helper.upperCase(kimlikNo),
                        value2: null
                    },
                    {
                        fieldName: "id",
                        operator: "=",
                        value1: kimlikId,
                        not: true
                    }
                ]
            }
        });
    }
    getPasaportNoVarMi = (pasaportNo: string, kimlikId: number) => {
        return this.service.find({
            filters: {
                groupOperator: 'and',
                predicates: [
                    {
                        fieldName: 'pasaportNo',
                        operator: '=',
                        value1: helper.upperCase(pasaportNo),
                        value2: null
                    },
                    {
                        fieldName: "id",
                        operator: "=",
                        value1: kimlikId,
                        not: true
                    }
                ]
            }
        });
    }

    getArama = (searchText: string) => {
        return this.service.get<Array<VwKimlikDTO>>("GetBySearchText", {
            searchText
        })

    }
    getDetayliArama = (aramaModel: VwKimlikDTO) => {
        return this.service.post<Array<VwKimlikDTO>>("KimlikDetayliArama", aramaModel)
    }
}
export default new VwKimlikService();